import { webAuth } from "./webAuthLogin";
import axiosInstance from "./axiosInstance";

export const applyForJob = async (jobApplicationData) => {
  try {
    const webAuthResponse = await webAuth();

    if (webAuthResponse.loginResponse.status !== 200 || !webAuthResponse.loginResponse.data.token) {
      throw new Error(webAuthResponse.loginResponse.data.message || "Failed to login");
    }
    if (webAuthResponse.cookieResponse.status !== 200) {
      throw new Error(webAuthResponse.cookieResponse.data.message || "Failed to set http cookie");
    }

    const jobResponse = await axiosInstance.post("/backend/job/apply", jobApplicationData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    // Step 4: Logout after applying
    await axiosInstance.post("/backend/user/logout");

    return jobResponse.data;
  } catch (error) {
    console.error("Error in applyForJob:", error.response?.data || error.message);
    return { success: false, message: error.response?.data?.message || "Something went wrong" };
  }
};
